import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import {
  Book,
  Calendar,
  MessageSquare,
  Users,
  TrendingUp,
} from 'react-feather';
import useI18n from 'hooks/use-i18n';
import ButtonHeader from 'components/CustomButton/ButtonHeader';
import InputSearch from 'components/InputSearch/InputSearch';

import styles from 'styles/Profile.module.scss';
import { USER_METHODS } from '../../../constants/constants';

const DashboardHeader = ({ onSearch, setSearch }) => {
  const i18n = useI18n();
  const listButtonRight = [
    {
      icon: <Calendar size={18} />,
      text: i18n.t('calendarHome'),
      link: '/calendar',
      permission: [USER_METHODS.GET, 'user-events'],
    },
  ];

  return (
    <div>
      <div className="row mb-sm-1 mb-0">
        <div className="col-lg-4 align-middle">
          {/* <h3>Statistics</h3> */}
          {/* <InputSearch onSearch={onSearch} setSearch={setSearch} /> */}
        </div>
        <div className="col-lg-4 align-middle">
          {/* <h3>Continue to watch</h3> */}
          {/* <InputSearch onSearch={onSearch} setSearch={setSearch} /> */}
        </div>
        <div className="col-lg-4 align-middle">
          {/* <h3>Calendar</h3> */}
          {/* <ButtonHeader data={listButtonRight} /> */}
        </div>
      </div>
    </div>
  );
};

DashboardHeader.propTypes = {
  onSearch: PropTypes.func.isRequired,
  setSearch: PropTypes.func.isRequired,
};

export default DashboardHeader;
